import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';

// The build's REACT_APP_LOOP_AUTH_URL overrides the configured loop-pro authentication-api.
const LOOP_AUTH_URL = process.env.REACT_APP_LOOP_AUTH_URL;

export const findOrganization = async (organization: string): Promise<any> => {
  try {
    const base = (LOOP_AUTH_URL || config.uri.auth_url).replace(/\/+$/, '');
    const org = encodeURIComponent(organization);
    const uri = `${base}/api/organization/find?organization=${org}`;

    const options = {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
